<template>
  <div id="DeliveryPending">
    <h4 v-if="offer > 0" class="content" :class="status.template.code">
      <template v-if="isTempOfferCompleted">
        +{{ offer | toCurrency }}원<br />추가 가능
      </template>
      <template v-else>
        - 원
      </template>
    </h4>
    <h4 v-else class="content unacceptable" :class="status.template.code">
      배달 매출이 추가 한도 기준에 부합하지 않습니다.
    </h4>
    <button v-if="offer > 0" @click="connect" :disabled="clicked"  >
      <span>
        {{ status.template.down }}
      </span>
    </button>
    <button v-else disabled>
      <span>배달 매출 다시 산출하기 <i class="icon-right"></i></span>
    </button>
  </div>
</template>

<script>
import DeliveryService from '@/service/delivery/DeliveryService'

import { mapGetters } from 'vuex'

export default {
  name: 'DeliveryPending',
  data() {
    return {
      clicked: false
    }
  },
  computed: {
    ...mapGetters('delivery', {
      status: 'getStatus'
    }),
    ...mapGetters('delivery', {
      offer: 'getOffer'
    }),
    ...mapGetters('delivery', {
      credentialId: 'getCredentialId'
    }),
    ...mapGetters('delivery', {
      isTempOfferCompleted: 'getTempOfferStatus'
    }),
  },
  methods: {
    async connect() {
      if (!this.isTempOfferCompleted) {
        this.$swal.fire({
          html: '배달매출을 산출중입니다.<br>잠시만 기다려주세요!',
          confirmButtonText: '확인'
        })
        return
      }

      if (this.offer < 0) {
        this.$swal.fire({
          html: '배달 매출이 추가 한도 기준에 부합하지 않습니다.',
          confirmButtonText: '확인'
        })
        return
      }

      try {
        this.clicked = true
        await DeliveryService.connect()
        this.$router.go()
      } catch (e) {
        this.$swal.fire({
          html: '문제가 발생했습니다. 다시 시도해주세요!',
          confirmButtonText: '확인'
        })
      } finally {
        this.clicked = false
      }
    },
  },
}
</script>
